import React, { lazy, useState, useEffect } from 'react'
import {
  CBadge,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CCallout
} from 'compat/coreui'
import CIcon from 'compat/coreui-icon'
import axios from 'axios';

import MainChartExample from '../charts/MainChartExample.js'

const Visitors = () => {
  const [analyticsData, setAnalyticsData] = useState([])
  const token = localStorage.getItem('token');

  useEffect(() => {
    getAnalyticsData();
  }, [])

   const getAnalyticsData = () =>{
        axios({
          url: `${process.env.REACT_APP_APP_API_URL}/api/dashboard`,
          method: 'GET',
          headers: {
            'Authorization': 'Bearer '+token
          }
        }).then(response => {
            if(response.data.status){
              setAnalyticsData(response.data.visitors);
            }
      }).catch(console.log)
  }


  return (
    <>
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm="5">
              <h4 style={{ fontSize: "200%" }} id="traffic" className="card-title mb-0">Visitors</h4>
              <div className="small text-muted">
             {analyticsData && analyticsData.map((item, i)=> {
                return(
                  <span key={i} style={{ fontSize: "180%", color: "red", fontWeight: "400", padding: "2px", marginLeft: "5px" }}>{item.count}</span>
                  )
              })}
                {/* <span key={i} style={{ fontSize: "180%", color: "red", fontWeight: "400", padding: "2px", marginLeft: "5px" }}>{item.count}</span> */}
                <span> ALL TIME VISITORS</span>
              </div>
            </CCol>
            <CCol sm="7" className="d-none d-md-block">
              <CButton color="primary" className="float-right">
                <CIcon name="cil-cloud-download" />
              </CButton>
              <CButtonGroup className="float-right mr-3">
                {
                  ['Day', 'Month', 'Year'].map(value => (
                    <CButton
                      color="outline-secondary"
                      key={value}
                      className="mx-0"
                      active={value === 'Month'}
                    >
                      {value}
                    </CButton>
                  ))
                }
              </CButtonGroup>
            </CCol>
          </CRow>
          <MainChartExample style={{ height: '300px', marginTop: '40px' }} />
        </CCardBody>
        <CCardFooter style={{display: "none"}}>
          <CRow className="text-center">
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Visits</div>
              <strong>29.703 Users (40%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="success"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
              <div className="text-muted">Unique</div>
              <strong>24.093 Users (20%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="info"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Pageviews</div>
              <strong>78.706 Views (60%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="warning"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">New Users</div>
              <strong>22.123 Users (80%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="danger"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
              <div className="text-muted">Bounce Rate</div>
              <strong>Average Rate (40.15%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                value={40}
              />
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
      <div style={{ width: "30%" }}>

        <CCard>
          <CCardHeader style={{ fontSize: "120%" }} className="category_header">
            Recent Visits
        </CCardHeader>
          <CCardBody>
            <div>
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Visits</th>
                  </tr>
                </thead>
                <tbody>
                  <tr key={1}>
                    <td>{"index"}</td>
                    <td>{"Date"}</td>
                  </tr>
                  <tr key={1}>
                    <td>{"index"}</td>
                    <td>{"Date"}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </CCardBody>
        </CCard>
      </div>

    </>
  )
}

export default Visitors
